import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { CalculatorAmountBlock, CalculatorFrameTop } from 'apps/auth/components/common/Calculator/styles';
import { CurrencyPanel } from 'apps/auth/components/common/Calculator/subcomponents/CurrencyPanel';
import ErrorDetails from 'apps/auth/components/common/Calculator/subcomponents/ErrorDetails';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { AMOUNT_TO, AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { getCurrencyIcon, onIconRenderError } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { CurrencyService } from 'apps/auth/services/currencyService';
import { FontSizeService } from 'apps/auth/services/fontSizeService';

import CalculatorInputAmountForRequest from './CalculatorInputAmountForRequest';
import CalculatorCurrenciesPopup from '../ga/accounts/send/popups/CalculatorCurrenciesPopup';

const CalculatorForRequest = (props) => {
    const { toCountry, commission, fromCountry } = useExtra();
    const currenciesTo = toCountry.currencies;
    const [fontSize, setFontSize] = useState('');
    const popupRef = useRef(null);
    const { selectCurrencyTitle } = usePageMessages();
    const fontSizeService = useMemo(() => new FontSizeService(), []);

    useEffect(() => {
        updateFontSize();
    }, []);

    const updateFontSize = () => {
        setFontSize(fontSizeService.calc(props.amountTo.value));
    };

    const getPopupComponent = ({ currencies, amountCcy }) => {
        return (
            <CalculatorCurrenciesPopup
                formName={props.formName}
                currencies={currencies}
                current={amountCcy}
                fromCountryCode={fromCountry.code}
                isRequest
                title={selectCurrencyTitle}
                popupRef={popupRef}
                getCurrencyIcon={getCurrencyIcon}
                onIconRenderError={onIconRenderError}
            />
        );
    };

    const onSelectCurrencyClick = (_e, currencies, amountCcy) => {
        popupRef.current?.open({ currencies, amountCcy });
    };

    return (
        <>
            <CalculatorFrameTop>
                <CalculatorAmountBlock>
                    <CalculatorInputAmountForRequest
                        formName={props.formName}
                        amountField={props.amountTo}
                        ccyField={props.amountToCcy}
                        title={props.amountTo.placeholder}
                        maxAmount={commission?.restrictionTo?.maxAmount}
                        minAmount={commission?.restrictionTo?.minAmount}
                        currencyCode={commission?.restrictionTo?.ccyIso}
                        enabledValidateMinMaxAmount={true}
                        customFontSize={fontSize}
                        updateFontSize={updateFontSize}
                        focus
                    />
                    {props.amountTo.isError ? (
                        <ErrorDetails
                            amountField={props.amountTo}
                            errorMessage={props.amountTo.errorMessage}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                        />
                    ) : (
                        <CurrencyPanel
                            currencies={currenciesTo}
                            currency={CurrencyService.getCurrentCurrency(currenciesTo, props.amountToCcy.value)}
                            ccyField={props.amountToCcy}
                            onSelectCurrencyClick={onSelectCurrencyClick}
                            isRequest
                        />
                    )}
                </CalculatorAmountBlock>
            </CalculatorFrameTop>
            <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} />
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
        amountToCcy: state.form[ownProps.formName].fields[AMOUNT_TO_CCY],
    };
};

export default connect(mapStateToProps)(CalculatorForRequest);
